import styled from "styled-components";

const FooterCopyRightLogo = styled.div``;

export default FooterCopyRightLogo;